

























































































































































import Vue from 'vue';
import { Form } from 'element-ui';
import { exportFiles, formatUrl, exportPostFiles } from '../../common/util';
import config from '../../config/index';

declare var captcha: any;

interface LibraryFindData {
  ruleForm: any,
  rules: any,
  degreeList: any,
  $refs: any,
  step: number,           // 步骤
  searchTime: any,      // 检索结果
  percentage: number,     // 解析进度百分比
  checkConfirm: boolean,  // 开检前确认
  extractResult: any,     // 解析结果
  warnVisible: boolean,
  isCheckTip: boolean,
  checkTime: number,
  isFeedTip: boolean,
  isAbandonTip: boolean,
  isParsingTip: boolean,
  pickerOption: any,      // 时间选择限制
  isCanUse: boolean,
  retrieveLoading: boolean,
  intervalPay: any
}

export default Vue.extend({
  name: 'LibraryFind',
  props: ["tab", "checkdbidList", "folderForm", "isDb"],
  data(): LibraryFindData {
    return {
      degreeList: ['博士', '硕士'],
      step: 1,
      searchTime: {
          hour: 0,
          minute: 0,
          second: 0
      },
      percentage: 0,
      checkConfirm: false,
      extractResult: {
          errorCount: 0,
          batchId: '',
          status: '',
          totalCount: 0
      },
      isCheckTip: false,
      isFeedTip: false,
      isAbandonTip: false,
      isParsingTip: false,
      warnVisible: false,
      checkTime: 0,
      isCanUse: true,
      retrieveLoading: false,
      intervalPay: null,
      ruleForm: {
        source: '',
        year: '',
        degreeType: '',
        major: '',
        tutor: '',
        title: '',
        author: ''
      },
      $refs: {
        ruleForm: Form
      },
      pickerOption: {
        disabledDate(time: Date) {   
          return time.getTime() < (new Date("1900/01/01 00:00:00").getTime()/1000);
        }
      },
      rules: {
        source: [{
          required: true,
          validator: (rule: any, value: any, callback: any) => {
            if (value === '') {
              callback(new Error('请输入学位授予单位'));
            } else if(value.length > 50) {
              callback(new Error('学位授予单位不超过50字符'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        year: [{
          required: true,
          validator: (rule: any, value: any, callback: any) => {
            if (value === '') {
              callback(new Error('请选择学位授予年份'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        degreeType: [{
          required: true,
          validator: (rule: any, value: any, callback: any) => {
            if (value === '') {
              callback(new Error('请选择学位类型'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        major: [{
          validator: (rule: any, value: any, callback: any) => {
            if(value.length > 30) {
              callback(new Error('专业不超过30字符'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        tutor: [{
          validator: (rule: any, value: any, callback: any) => {
            if(value.length > 30) {
              callback(new Error('导师不超过30字符'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        title: [{
          validator: (rule: any, value: any, callback: any) => {
            if(value.length > 200) {
              callback(new Error('题名不超过200字符'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        author: [{
          validator: (rule: any, value: any, callback: any) => {
            if(value.length > 150) {
              callback(new Error('作者不超过150字符'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
      }
    };
  },
  computed: {
    formula() {
      let obj: any = (this as any).ruleForm;
      let str = `(学位授予单位(${obj.source}) and 学位:(${obj.degreeType})) and Date:${obj.year}`;
      if(obj.major) str = `${str} and 专业:${obj.major}`;
      if(obj.tutor) str = `${str} and 导师:${obj.tutor}`;
      if(obj.title) str = `${str} and 题名:${obj.title}`;
      if(obj.author) str = `${str} and 作者:${obj.author}`;
      return str;
    }
  },
  watch: {
    tab(val: string) {
      if(val === 'find') {
        this.checkCanSearch();
      }
    }
  },
  methods: {
    // 开始检索
    handleRetrieve() {
      (this.$refs.ruleForm as any).validate((valid: any) => {
          if (valid) {
              this.retrieveLoading = true;
              this.$http.post(`/api/Search/SearchPaperCount`, this.ruleForm).then((res: any) => {
                this.retrieveLoading = false;
                if(res.data.success) {
                  this.extractResult.totalCount = res.data.totalCount;
                  this.step = 2;
                  this.handleCountTime();
                } else {
                  this.$message.error(res.data.message);
                }
              });
          }
      });
    },
    // 秒转时分秒
    formatSeconds(value: any) {
      let result = parseInt(value)
      let h = Math.floor(result / 3600) < 10 ? Math.floor(result / 3600) : Math.floor(result / 3600);
      let m = Math.floor((result / 60 % 60)) < 10 ? Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
      let s = Math.floor((result % 60)) < 10 ? Math.floor((result % 60)) : Math.floor((result % 60));
  
      let res = '';res += `${h}-`;res += `${m}-`;
      // if(h !== 0) res += `${h}-`;
      // if(m !== 0) res += `${m}-`;
      res += `${s}`;
      return res;
    },
    // 计算抽取解析需要时间
    handleCountTime() {
      let second = this.extractResult.totalCount * 5;  // 一秒一个
      let time = this.formatSeconds(second).split('-');
      this.searchTime.hour = parseInt(time[0]);
      this.searchTime.minute = parseInt(time[1]);
      this.searchTime.second = parseInt(time[2]);
    },
    // 获取库内查询按钮是否可用 一天内放弃三次就禁用 false 不可用，true 可用
    checkCanSearch() {
      this.$http.get(`/api/Search/IsCanUseSearch`).then((res: any) => {
        this.isCanUse = res.data;
      });
    },
    // 获取最新的检索
    fetchGetStatus() {
      this.$http.get(`/api/Search/GetStatus`).then((res: any) => {
        this.extractResult = res.data;
        if(this.extractResult.status === 'Processing') {
          this.step = 3;
          let that = this;
          clearInterval(this.intervalPay);
          this.intervalPay = null;
          this.intervalPay = setInterval(() => {
            setTimeout(() =>{ that.fetchProgress() }, 0);
          }, 5000);
        } else if(this.extractResult.status === 'WaitForCheck') {
          this.step = 4;
        } else {
          this.step = 1;
        }
      });
    },
    continueCheck() {
      this.isCheckTip = false;
      this.backInitial();
    },
    // 点击开始抽取解析文本按钮
    bindInitial() {
      if(this.extractResult.totalCount) {
        this.isParsingTip = true;
      } else {
        this.$message({
          message: '无检索结果，请返回重新检索',
          type: 'error'
        });
      }
    },
    // 下载检索结果列表
    downloadSearch() {
      if(this.extractResult.totalCount) {
        this.$http.post(`/api/Search/DownloadList`, this.ruleForm, {
            responseType: 'blob'
        }).then((res: any) => {
            let headerFileName = res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1];
            headerFileName = decodeURIComponent(headerFileName);
            headerFileName = headerFileName ? headerFileName : '检索结果列表';
            exportPostFiles(res.data, headerFileName);
        });
      } else {
        this.$message({
          message: '无检索结果，请返回重新检索',
          type: 'error'
        });
      }
    },
    backInitialFinish() {
      if(this.checkConfirm) {
        this.$http.post(`/api/Search/AbandonCheck`, {
          batchId: this.extractResult.batchId,
          status: 'Finish'
        }).then((res: any) => {
          if(res.status === 200) {
            this.backInitial();
          }
        });
      } else {
         this.$alert('请勾选确认知晓内容', '提示');
      }
    },
    // 返回重新检索
    backInitial() {
        this.ruleForm = {
          source: '',
          year: '',
          degreeType: '',
          major: '',
          tutor: '',
          title: '',
          author: ''
        };
        this.searchTime = {
          hour: 0,
          minute: 0,
          second: 0
        };
        this.extractResult = {
          errorCount: 0,
          batchId: '',
          status: '',
          totalCount: 0
        };
        localStorage.removeItem('findSet');
        this.step = 1;
    },
    // 获取失败记录
    fetchFailLog() {
      exportFiles(formatUrl({}, `${config.api}/api/Search/DownloadErrorList`));
    },
    // 一键反馈错误
    feedbackErr() {
      this.isFeedTip = true;
    },
    // 跳转到检测结果
    toCheckResult() {
      let path = '/myCheckInfo';
     
      this.$router.push({
        path
      });
    },
    // 确认放弃检测
    confirmAbandon() {
      this.$http.post(`/api/Search/AbandonCheck`, {
        batchId: this.extractResult.batchId,
        status: 'Abandon'
      }).then((res: any) => {
        if(res.status === 200) {
          this.fetchGetStatus();
          this.checkCanSearch();
          this.backInitial();
          this.isAbandonTip = false;   
        }
      });
    },
    // 开始检测
    async startCheck() {
        if(this.extractResult.errorCount && !this.checkConfirm) {
            // 有解析错误且没点击复选框
            this.warnVisible = true;
        } else {
            this.warnVisible = false;
            if(this.checkdbidList.length === 0) {
              this.$alert(' 请至少选择一个比对库！', '提示');
              return;
            }     
            if(!this.isDb){
              await this.$emit("checkDb");
            }
            this.confirmStartCheck();
        }
    },
    // 确认开始检测
    confirmStartCheck () {
      let sloading = this.$loading({
        lock: true,
        text: '正在检测...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let params: any = {
        checkDBIds: this.checkdbidList.join(','),
        nvc: captcha.getNVCVal(),
        publishYear: this.ruleForm.year,
        degreeType: this.ruleForm.degreeType,
        batchId: this.extractResult.batchId
      };
      this.folderForm.taskId ? params.taskId = this.folderForm.taskId : '';
      this.$http.post(`/api/HDCheck/BeginCheck`, params).then((data: any) => {
        sloading.close();
        // 无痕验证未通过
        if (!captcha.callback(data.data)) {
          this.$store.dispatch('setLoading', {
            isShow: false
          });
          return;
        } else if(data.data.success) {
          this.$message({
            message: `送检成功`,
            type: 'success'
          });
          this.checkTime = data.data.checkTime;
          this.isCheckTip = true;
        } else {
          if (data.data.message === '余额不足') {
            this.$alert('您的账户余额不足，请联系管理员充值!', '提示');
          } else if (data.data.message === '交易错误') {
            this.$alert('交易错误，请稍后重试!', '提示');
          } else {
            this.$message({
              message: data.data.message,
              type: 'error'
            });
          }
        }
      }).catch(() => {
        sloading.close();
        this.$store.dispatch('setLoading', {
          isShow: false
        });
      });
    },
    // 获取进度
    fetchProgress(){
      this.$http.get(`/api/Search/GetStatus?batchId=${this.extractResult.batchId}`).then((res: any) => {
        this.extractResult = res.data;
        const that = this;
        if(res.data.status !== 'Processing'){
          clearInterval(that.intervalPay)
          that.intervalPay = null;
          this.step = 4;
        } else {
          console.log(res.data.successCount);
          console.log(res.data.totalCount);

          let num: any = (res.data.successCount / res.data.totalCount) * 100;
          this.percentage = Math.round(num);
           
          console.log(res.data.successCount / res.data.totalCount);
          console.log(num);
          console.log(this.percentage);
          console.log(",,,,,,");
        }
      });
    },
    // 开始抽取解析文本
    startParsing() {
      this.isParsingTip = false;
      this.$http.post(`/api/Search/BeginExtractAndSave`, this.ruleForm).then((res: any) => {
        if(res.data.success) {
          this.extractResult = res.data.result;
          if(this.extractResult.status === 'WaitForCheck') {
            this.step = 4;
          } else if(this.extractResult.status === 'Processing') {
              this.step = 3;
              let that = this;
              clearInterval(this.intervalPay);
              this.intervalPay = null;
              this.intervalPay = setInterval(() => {
                setTimeout(() =>{ that.fetchProgress() }, 0);
              }, 5000);
          }
        } else {
          let msg = '';
          if(res.data.message === 'Forbidden') {
            msg = '当日已放弃检测3次，今日不能继续使用库内查找功能';
          } else {
            msg = res.data.message;
          }
          this.$message.error(msg);
        }
      });
    }
  },
  mounted() {
    this.fetchGetStatus();
  }
});
